import { render, staticRenderFns } from "./pieEchart.vue?vue&type=template&id=48c7f8b8&scoped=true"
import script from "./pieEchart.vue?vue&type=script&lang=js"
export * from "./pieEchart.vue?vue&type=script&lang=js"
import style0 from "./pieEchart.vue?vue&type=style&index=0&id=48c7f8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c7f8b8",
  null
  
)

export default component.exports